<template>
  <section class="bg-orange-500 px-4 py-16 sm:py-24">
    <div class="mx-auto w-full max-w-5xl">
      <h2 class="mb-12 text-center text-3xl font-bold text-black md:text-4xl">
        Selos de Qualidade
      </h2>

      <!-- Container: coluna no mobile, linha no desktop -->
      <div
        class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-12"
      >
        <!-- IMAGENS: aparecem ABAIXO no mobile (order-2), e À ESQUERDA no desktop (lg:order-1) -->
        <div class="flex flex-col items-center gap-8 order-2 lg:order-1">
          <img
            :src="founderPrime"
            alt="Selo Prime"
            class="w-52 h-auto rounded-xl shadow-xl"
          />
          <img
            :src="founderVerificado"
            alt="Selo Verified"
            class="w-52 h-auto rounded-xl shadow-xl"
          />
        </div>

        <!-- LISTA: aparece ACIMA no mobile (order-1), e À DIREITA no desktop (lg:order-2) -->
        <div class="max-w-md order-1 lg:order-2">
          <h3
            class="text-2xl font-bold text-black mb-6 tracking-wide text-center lg:text-left"
          >
            A OVER X é uma startup verificada pelo Founders Club
          </h3>

          <ul class="space-y-4 text-black text-lg font-medium">
            <li class="flex items-start gap-3">
              <span class="text-black text-2xl leading-none">•</span>
              Reconhecimento oficial da comunidade Founders Club
            </li>
            <li class="flex items-start gap-3">
              <span class="text-black text-2xl leading-none">•</span>
              Selo Prime que destaca empresas de alta confiabilidade
            </li>
            <li class="flex items-start gap-3">
              <span class="text-black text-2xl leading-none">•</span>
              Certificação Verificada para startups qualificadas
            </li>
            <li class="flex items-start gap-3">
              <span class="text-black text-2xl leading-none">•</span>
              Demonstra comprometimento com qualidade e inovação
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import founderVerificado from "@/assets/selo_founders_club_verificada.png";
import founderPrime from "@/assets/selo_founders_club_prime.png";

export default {
  name: "SelosCard",
  data() {
    return {
      founderVerificado,
      founderPrime,
    };
  },
};
</script>
